import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormModal, FormInput } from '../../../../../../onestep-library/BaseUI/'
import { submitVerifyPaymentSource } from './actions'


function VerifyPaymentSource(props){
  const dispatch = useDispatch()
  const { verifyPaymentSourceForm } = useSelector(state=>state)
  const { amount1, amount2, ui, errors, name } = verifyPaymentSourceForm
  const { show, is_submitting, callback_action } = ui
  const updateVerifyPaymentSourceFormField = (payload) => dispatch({type:"UPDATE_VERIFY_PAYMENT_SOURCE_FIELD", payload})

  function onClose(){
    dispatch({type: callback_action, payload: { show: true } })
    dispatch({type: 'RESET_VERIFY_PAYMENT_SOURCE_FORM'})
  }

  function onValidateRequiredFields(){
    return(
      amount1.length > 0 &&
      amount2.length > 0
    )
  }

  function onSubmit(){
    dispatch(submitVerifyPaymentSource(onClose))
  }

  function onErrors(){

  }

  return(
    <FormModal
      show={show} 
      title={`Verify ${name}`}
      isSubmitting={is_submitting}
      submitButtonLabel={`Verify ${name}`}
      errors={errors}
      handleClose={onClose} 
      handleValidateRequiredFields={onValidateRequiredFields}
      handleSubmit={onSubmit}
      handleErrors={onErrors}>
      <div className="pb-3">
        Bank accounts must be verified before use. 
        To verify, enter the amounts of two small deposits made into the account. 
        The statement description for these deposits will be AMNTS. 
        Please allow 1-2 business days for the deposits to show.
      </div>
      <FormInput
        label="Account Name"
        value={name}
        disabled/>
      <FormInput
        type="number"
        label="Amount 1"
        value={amount1}
        handleChange={(amount1)=>updateVerifyPaymentSourceFormField({amount1})}/>
      <FormInput
        type="number"
        label="Amount 2"
        value={amount2}
        handleChange={(amount2)=>updateVerifyPaymentSourceFormField({amount2})}/>
    </FormModal>
  )
}

export default VerifyPaymentSource